import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path:'/rms',
    component: Layout,
    redirect: '/rms/applyCodeRecord',
    name: 'rms',
    meta: {title: '记录', icon: 'rms'},
    children: [
      {
        path: 'applyCodeRecord',
        name: 'applyCodeRecord',
        component: () => import('@/views/ums/applyCodeRecord/index'),
        meta: {title: '申请记录'}
      },
      {
        path: 'requestCodeRecord',
        name: 'requestCodeRecord',
        component: () => import('@/views/ums/requestCodeRecord2/index'),
        meta: {title: '请求记录'}
      },
      {
        path: 'loginLogoutRecord',
        name: 'loginLogoutRecord',
        component: () => import('@/views/ums/loginLogoutRecord/index'),
        meta: {title: '登入登出'}
      },
      {
        path: 'operatorRecord',
        name: 'operatorRecord',
        component: () => import('@/views/ums/operatorRecord/index'),
        meta: {title: '操作记录'}
      },
      {
        path: 'countInfoRecord',
        name: 'countInfoRecord',
        component: () => import('@/views/ums/countInfoRecord/index'),
        meta: {title: '数量信息'}
      },
      {
        path: 'errorLogRecord',
        name: 'errorLogRecord',
        component: () => import('@/views/ums/errorLogRecord/index'),
        meta: {title: '错误日志'}
      },
      {
        path: 'fileInfo',
        name: 'fileInfo',
        component: () => import('@/views/ums/fileInfo/index'),
        meta: {title: '文件列表'}
      },
      {
        path: 'uploadFile',
        name: 'uploadFile',
        component: () => import('@/views/ums/fileInfo/upload'),
        meta: {title: '添加文件'},
        hidden: true
      },
      {
        path: 'addFolder',
        name: 'addFolder',
        component: () => import('@/views/ums/fileInfo/add'),
        meta: {title: '添加文件夹'},
        hidden: true
      },
      {
        path: 'updateFileInfo',
        name: 'updateFileInfo',
        component: () => import('@/views/ums/fileInfo/update'),
        meta: {title: '更新文件夹'},
        hidden: true
      },
      {
        path: 'allocFileInfo',
        name: 'allocFileInfo',
        component: () => import('@/views/ums/fileInfo/allocFileInfo'),
        meta: {title: '分配权限'},
        hidden: true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'macAddressList',
        name: 'macAddressList',
        component: () => import('@/views/ums/macAddressList/index'),
        meta: {title: 'mac地址管理'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源路径列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  //路由切换使页面滚动到顶部
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js